import React, { useState } from 'react';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createDocuments } from 'api/documents';
import Button from 'components/Button';
import Popup from 'components/Popup';
import { UploadIcon } from '@phosphor-icons/react';

export default function DocumentPopupUpload({
    visible,
    setVisible,
    folderId
}) {

    const cache = useQueryClient();

    const [ files, setFiles ] = useState([]);

    const { mutate: create, status } = useMutation({
        mutationKey: ['createDocuments'],
        mutationFn: createDocuments,
        onSuccess: () => {
            cache.invalidateQueries(['documents', folderId]);
            return setVisible(false);
        },
        onError: (error) => {
            console.error("Error updating document-tag:", error);
        }
    });

    const handleFileChange = (event) => {
        const files = event.target.files;
        for (const file of files) {
            setFiles(prev => [...prev, file]);
        }
    }


    function onSubmitHandler() {
        console.log('Uploading files:', files, 'to folder:', folderId);
        return create({
            data: {
                files,
                folder: folderId
            }
        });
    }

    return (
        <Popup
            visible={visible}
            setVisible={setVisible}
        >
            <form action={onSubmitHandler} className='flex flex-col gap-4'>
                <div className="flex items-center justify-center w-full">
                    <label htmlFor="dropzone-file" className="flex flex-col items-center justify-center w-full h-32 border border-gray-300 border-dashed rounded-lg cursor-pointer hover:bg-grey">
                        <div className="flex flex-col items-center justify-center p-3 md:p-6">
                            <UploadIcon size={40} className="mb-2 text-white" />
                            <p className="text-sm text-center text-muted"><span className="font-semibold">Clicca</span> per caricare o trascina qui</p>
                        </div>
                        <input id="dropzone-file" type="file" className="hidden" multiple onChange={handleFileChange}/>
                    </label>
                </div> 
                <div className='flex justify-between pt-6'>
                    <Button submit status={status}>Carica</Button>
                </div>
            </form>
        </Popup>
    )
}
